import Request from './RequestHandler.js'

export default {
  index (params) {
    return Request.make('get', 'users', params)
  },

  show (id) {
    return Request.make('get', 'users/' + id)
  },
  create (params) {
    return Request.make('post', 'users', params)
  },
  update (id, params) {
    return Request.make('patch', 'users/' + id, params)
  },
  destroy (id) {
    return Request.make('delete', 'users/' + id)
  },
  filter (params) {
    return Request.make('get', 'users', params)
  }
}
